module.exports = __webpack_public_path__ + "static/media/icon_chua_co_tk.e1e54e4b.svg";